<div mat-dialog-content>
    <div class="cyclic-container-button">
        <button mat-icon-button (click)="onClose()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <app-invCyclicNew (closeDialog)="onClose()" [cyclicId]="cyclicId"></app-invCyclicNew>
</div>